export default __webpack_public_path__ + "static/media/zmiana-danych-konta.bd8406c1.png";